module.exports = __webpack_public_path__ + "img/9788936456269.7e36c668.jpg";